/**
 * Hide nav groups that have no links, for example when the user has no permission for any items
 * @param  {Node} el Element
 * @return {Void}
 */

export default function navGroup(el) {
  const links = el.querySelectorAll(".nav-list__link");

  if (links.length === 0) {
    el.style.display = "none";
  }
}
